import React, { useEffect, useState } from "react";
import FormInputs from "../../../components/UI/FormInputs";
import EmployeeService from "../../../services/EmployeeService";
import { USDateTimeString, isObject, isSet } from "../../../utils/commonUtils";
import TableGrid from "../../../components/UI/TableGrid";
import WithRoutify from "../../../hoc/WithRoutify";
import SectionLoader from "../../../components/UI/SectionLoader";
import LookupService from "../../../services/LookupService";
import { DOCUMENT_TYPE } from "../../../utils/constant";

const Documents = (props) => {
    const [uploadedFile,    setUploadedFile] = useState(null);
    const [isLoading,setLoaded] = useState(false);
    const [documentsList, setDocumentsList] = useState({ tableHeaders: [], tableRows: { data: [] } });
    const [documentFormData,setDocumentFormData]=useState({})
    const [lookupData,setLookupData]=useState({});
    const [validation,setValidation]=useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [activeSearchTerm, setActiveSearchTerm] = useState('');
    const [pagination, setPagination] = useState({
        sort_by: 'updated_at',
        sort_order: 'desc'
    });
    const [useApiFetch, setUseApiFetch] = useState(false);

    const fetchAdditionalDocumentList = async (search = activeSearchTerm, sortBy = pagination.sort_by, sortOrder = pagination.sort_order) => {
        try {
            let additionalDocuments = [];
            
            // If search or sort is active, fetch from API; otherwise use props data
            const hasSearch = search && search.trim() !== '';
            const hasCustomSort = sortBy !== 'updated_at' || sortOrder !== 'desc';
            
            if (useApiFetch || hasSearch || hasCustomSort) {
                setLoaded(true);
                const queryParams = {
                    employee_id: props.employeeId
                };
                if (hasSearch) {
                    queryParams.search = search;
                }
                if (sortBy) {
                    queryParams.sort_by = sortBy;
                }
                if (sortOrder) {
                    queryParams.sort_order = sortOrder;
                }
                const response = await EmployeeService.getAdditionalDocumentsList(queryParams);
                additionalDocuments = response?.documents || [];
                setLoaded(false);
            } else {
                additionalDocuments = isSet(props.formData.additional_documents, []);
            }
            
            const tableData = additionalDocuments.map((item) => ({
                rowId: item.additional_document_id,
                data: {
                    name: item.snap_file_manager || item.snapFileManager,
                    document_type: item.document_type,
                    updatedAt: USDateTimeString((item.snap_file_manager || item.snapFileManager)?.updated_at || item.updated_at),
                    action: [{
                        className: 'btn btn-icon btn-transparent-dark',
                        iconType: 'Remove',
                        acl: 'employee-delete',
                        title: 'Delete',
                        isDelete:true,
                        clickHandler: () => deleteHandler(item.additional_document_id),
                    }]
                }
            }));

            setDocumentsList({ tableHeaders: getTableHeaders(), tableRows: { data: tableData } });
        } catch (error) {
            console.error("Error fetching additional documents:", error);
            setLoaded(false);
        }
    }
    const fetchLookupsData = async () => {
        try {
            const [documentTypeData] = await Promise.all([
                LookupService.getLookupByKey(DOCUMENT_TYPE),
            ]);
            let documenTypeOptions = [{ label: '-None-', value: '' }];
            documentTypeData.forEach((item) => {
                documenTypeOptions.push({
                    label: item.value,
                    value: item.value
                });
            });
            console.log('document_type_data',documenTypeOptions);
            setLookupData({...lookupData,['document_type']:documenTypeOptions});
        } catch (e) {

        }
    }

    const getTableHeaders = () => [
        { label: 'File Name', key: 'name', type: 'FileType', sortName: 'file_name' },
        { label: 'Type', key: 'document_type', type: 'SelectList', sortName: 'document_type' },
        { label: 'Updated Date', key: 'updatedAt', type: '', sortName: 'updated_at' },
        { label: 'Action', key: 'action', type: 'Actions' },
        // Add more columns as needed
    ];

    const submiHandler = async () => {
        
        try {
            const formData = new FormData();
            formData.append('file', uploadedFile);
            formData.append('employee_id', props.employeeId);
            formData.append('document_type',documentFormData.document_type);
            setLoaded(true);
            const response=await EmployeeService.addAdditionalDocument(formData);
            setLoaded(false);
            let updateValidation={...validation};
            if (response.status && response.status == "ERROR") {
                if (isObject(response.data)) {
                  for (let key in response.data) {
                    updateValidation = {
                      ...updateValidation,
                      [key]: response.data[key].join(","),
                    };
                  }
                } else {
                  props.Toast.error(response.data);
                }
                if (Object.keys(updateValidation).length > 0) {
                  setValidation(updateValidation);
                  return;
                }
              }
            // Refresh the list - if using API fetch, use API; otherwise refresh from props
            if (useApiFetch) {
                fetchAdditionalDocumentList(activeSearchTerm, pagination.sort_by, pagination.sort_order);
            } else {
                props.fetchEmployeeDetails(props.employeeId);
            }
            setUploadedFile(null);
            setDocumentFormData({});
        } catch (error) {
            console.error("Error submitting document:", error);
            setLoaded(false);
        }
    }
    const inputFields = [
        {
            type: 'SelectList',
            options:lookupData.document_type ||[],
            label: 'Document Type',
            className: 'form-control form-control-solid',
            name: 'document_type'
        },
    ];

    const deleteHandler = async (additionalDocId) => {
        setLoaded(true);
        try {
            await EmployeeService.deleteAdditionalDocument(additionalDocId);
            props.Toast.success('Document Removed successfully');
            // Refresh the list - if using API fetch, use API; otherwise refresh from props
            if (useApiFetch) {
                fetchAdditionalDocumentList(activeSearchTerm, pagination.sort_by, pagination.sort_order);
            } else {
                props.fetchEmployeeDetails(props.employeeId);
            }
            setLoaded(false);
        } catch (error) {
            setLoaded(false);
            console.error("Error deleting document:", error);
        }
    }

    useEffect(() => {
        if (!useApiFetch && !activeSearchTerm && pagination.sort_by === 'updated_at' && pagination.sort_order === 'desc') {
            fetchAdditionalDocumentList();
        }
    }, [props.formData.additional_documents]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSearch = () => {
        setActiveSearchTerm(searchTerm);
        setUseApiFetch(true);
        fetchAdditionalDocumentList(searchTerm);
    };

    const handleClear = () => {
        setSearchTerm('');
        setActiveSearchTerm('');
        setPagination({
            sort_by: 'updated_at',
            sort_order: 'desc'
        });
        setUseApiFetch(false);
        fetchAdditionalDocumentList('', 'updated_at', 'desc');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const fetchTableRecords = (newPagination) => {
        setPagination(newPagination);
        setUseApiFetch(true);
        fetchAdditionalDocumentList(activeSearchTerm, newPagination.sort_by, newPagination.sort_order);
    };
    useEffect(()=>{
        fetchLookupsData();
    },[]);

    const changeHandler=(val,fieldName)=>{
    setDocumentFormData(prevState => ({
              ...prevState.labformData, [fieldName]: val }
        ));
        setValidation({...validation,[fieldName]:''});
    }

    return (
        <div className="sh_innerPortview">
            <div className="row">
                <div className="col-12 col-lg-4">
                <div className="sh_cardBox sh_cardbglight h-auto shadow-none border">
                    <div className="sh_cardBody p-3">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                <label className="text-sm text-truncate mb-0 opacity-75">{"Document"}</label>
                                    <FormInputs
                                        type='FileUpload'
                                        title="Field Document"
                                        className=''
                                        size={10}
                                        value={uploadedFile||''}
                                        changeHandler={(val) => { 
                                            setUploadedFile(val);
                                            setValidation(prevValidation => ({ ...prevValidation, file: '' }));
                                          }}
                                    />
                                        {isSet(validation['file'], "") !== "" ? (<span className="text-danger m-1"> {validation['file']}</span>)
                                            :
                                            ""
                                        }
                                </div>
                            </div>
                            {inputFields.map((item, index) => (
                                    <div className="col-12" key={index}>
                                        <div className="form-group">
                                            <label className="text-sm text-truncate mb-0 opacity-75">{item.label}</label>
                                            <FormInputs
                                                {...item}
                                                value={isSet(documentFormData[item.name], '')}
                                                changeHandler={(val) => changeHandler(val, item.name)}
                                            />
                                           {isSet(validation[item.name], "") !== "" ? (<span className="text-danger m-1"> {validation[item.name]}</span>)
                                             :
                                            ""
                                            }
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                    <div className="sh_cardFooter justify-content-center">
                        <button className="btn btn-primary btn-sm text-sm" onClick={submiHandler}> Add </button>
                    </div>
                </div>
                </div>
                <div className="col-12 col-lg-8">
                
                <div className="sh_cardBox sh_cardbglight h-auto shadow-none border">
                    <div className="sh_cardHeader">
                        <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                            <h6 className="text-md mb-0">Document List </h6>
                        </div>
                    </div>
                    <div className="sh_cardBody p-0">
                        {/* Search Input and Buttons */}
                        <div className="p-3 border-bottom">
                            <div className="d-flex justify-content-end sh_filter_formheader">
                                {/* Search Input */}
                                <div className="d-flex p-1">
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            onKeyPress={handleKeyPress}
                                        />
                                    </div>
                                </div>
                                {/* Action Buttons */}
                                <div className="d-flex">
                                    <div className="addAction mr-2">
                                        <div className="btn-group p-1">
                                            <button
                                                className="btn btn-primary"
                                                onClick={handleSearch}
                                            >
                                                Search
                                            </button>
                                            <button
                                                className="btn btn-outline-secondary"
                                                style={{ backgroundColor: 'white' }}
                                                onClick={handleClear}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SectionLoader isLoading={isLoading}/>
                        {documentsList.tableRows.data.length > 0 ? (
                            <TableGrid 
                                {...documentsList} 
                                pagination={pagination}
                                fetchTableRecords={fetchTableRecords}
                            />
                        ) : (
                            <div className="p-3 text-center text-muted">
                                {activeSearchTerm ? 'No documents found matching your search.' : 'No documents uploaded yet.'}
                            </div>
                        )}
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
}

export default WithRoutify(Documents);
